import { render } from "./CareerProfile.vue?vue&type=template&id=42c6967e"
import script from "./CareerProfile.vue?vue&type=script&lang=js"
export * from "./CareerProfile.vue?vue&type=script&lang=js"

import "./CareerProfile.vue?vue&type=style&index=0&id=42c6967e&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\projects\\gvnpro\\employment\\candidate.dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__